<template>
  <div>
    <a-card title="添加产品分类" :bordered="false">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="分类名称"
        >
          <a-input
            v-decorator="[
          'text',
          {rules: [{ required: true, message: '必填项' }]}
        ]"
            placeholder="分类名称"
          />
        </a-form-item>
         <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="分类编码"
        >
          <a-input
            v-decorator="[
          'value',
          {rules: [{ required: true, message: '必填项' }]}
        ]"
            placeholder="分类编码"
          />
        </a-form-item>
       
        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
          <div>
            <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
            <a-button @click="goBack">取消</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
export default {
  name: "productGrouppAdd",
  created() {
  },
  data() {
    return {
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/api/1.0/productGroup/save", values).then(res => {
            this.$http.ajaxResultDue(res, "/productGroup", null);
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.ant-input-number {
  width: 100%;
}
</style>

